import React, { useState } from 'react';
import { PaymentFooter, Button as MuiButton, useGlobal } from '@rcg/ui-react';
import { Box, Typography } from '@material-ui/core';
import Modal from '../Modal';
import { ReactComponent as WarningIcon } from '../../assets/svg/warning-icon.svg';
import { ReactComponent as CloseIcon } from '../../assets/svg/close-x_blue.svg';
import Styles from './index.style';
import PaymentStyles from '../../pages/Payment/index.style';

const PaymentFooterWithModal = ({
  tooltipContent,
  tooltipLabel,
  submitPayment,
  setFirstValueCheckbox,
  isCheckedCruiseTicket,
  setIsCheckedCruiseTicket,
  showLineError,
  setShowLineError,
  isPaymentPage = false,
  affirmChecked = null,
  ctaTitle,
}) => {
  const ownClasses = Styles();
  const classes = PaymentStyles();

  const { renderContent } = useGlobal();

  const [openModalTermsAndCondition, setOpenModalTermsAndCondition] = useState(false);

  const handleOpenModal = (event) => {
    event.preventDefault();
    setOpenModalTermsAndCondition(true);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleOpenModal(event);
    }
  };

  const handleCloseModal = () => {
    setOpenModalTermsAndCondition(false);
  };

  const handleCheckboxValue = (event) => {
    if (!event.target.checked) {
      setShowLineError(true);
    } else {
      setShowLineError(false);
    }

    setIsCheckedCruiseTicket(event.target.checked);
    setFirstValueCheckbox(false);
  };

  const submitCTA = () => {
    if (isPaymentPage) {
      if (!affirmChecked) {
        return renderContent('amendPaymentFooterSummaryButtonLabel', 'Make Payment');
      }
      return renderContent('amendPaymentFooterSummaryButtonAffirmLabel', 'Pay with Affirm');
    }
    return ctaTitle;
  };

  const paymentSummaryLabel = () => {
    if (isPaymentPage) {
      return renderContent('amendPaymentFooterSummaryLabel', 'Pay now: ');
    }
    return renderContent('amendPaymentFooterUPSummaryLabel', 'Due today: ');
  };

  const checkboxLabel = (
    <div className={ownClasses.checkboxLabel}>
      <p>
        {renderContent('amendCheckboxLabelFooterPayment', 'Agree to the ')}
        <span
          data-testid="checkbox-open-modal-element"
          className={ownClasses.linkCheckbox}
          tabIndex={0}
          role="button"
          onClick={(event) => handleOpenModal(event)}
          onKeyPress={handleKeyPress}>
          {renderContent(
            'amendCheckboxOpenModalFooterPayment',
            'Cruise Contract and to receive balance due communications',
          )}
        </span>
      </p>
      {!isCheckedCruiseTicket && (
        <div className={ownClasses.errorMessage}>
          <WarningIcon width={16} height={16} />
          <Typography>
            {renderContent(
              'amendCheckboxErrorFooterPayment',
              'Please acknowledge the ticket contract to continue',
            )}
          </Typography>
        </div>
      )}
    </div>
  );

  return (
    <>
      <div className={showLineError && ownClasses.error}>
        <div className={ownClasses.footerContainer}>
          <PaymentFooter
            showTooltip
            tooltipContent={tooltipContent}
            tooltipLabel={tooltipLabel}
            checkboxLabel={checkboxLabel}
            paymentSummaryLabel={paymentSummaryLabel()}
            submitCTA={submitCTA()}
            className={classes.paymentFooterAmend}
            submitHandler={submitPayment}
            showTermsAndConditionsCheckBox
            onChangeCheckBox={(event) => handleCheckboxValue(event)}
          />
        </div>
      </div>
      <Modal onClose={handleCloseModal} open={openModalTermsAndCondition}>
        <Box className={ownClasses.modalContainer}>
          <div className={ownClasses.modalHeader}>
            <Typography variant="h1" className="title">
              {renderContent(
                'bookingAmendPaymentFooterCheckboxLinkLabel',
                'Cruise Ticket Contract',
              )}
            </Typography>
            <MuiButton
              variant="text"
              onClick={handleCloseModal}
              disableTouchRipple
              aria-label="Close modal"
              data-testid="modal-close-button-footer-payment">
              <CloseIcon />
            </MuiButton>
          </div>
          <Box className="content">
            <Typography>
              {renderContent(
                'amendModalContentNoticePaymentFooter',
                'IMPORTANT NOTICE TO GUESTS: Your cruise ticket contract or booking conditions, and the terms and conditions for the purchase of any products, services, shore excursions, or other activities related to your cruise, contain important limitations on the rights of passengers, including provisions relating to limitation of liability, forum selection, governing law, and the use of alternative dispute resolution to resolve certain types of disputes. To find the applicable cruise ticket contract or booking conditions, and the purchase terms and conditions, please visit ',
              )}
              <a
                href="https://www.royalcaribbean.com/guest-terms/"
                target="_blank"
                rel="noopener noreferrer">
                www.royalcaribbean.com/guest-terms/
              </a>
            </Typography>
            <Typography className={ownClasses.footerModal}>
              {renderContent(
                'amendModalContentHATextPaymentFooter',
                'To ensure your booking is not inadvertently cancelled, we may need to contact you or others in your traveling party.  By proceeding, you - on your own behalf and on behalf of all others you represent - agree to receive communications from us, at any time we deem appropriate, about any outstanding balance(s) or amount(s) due. This includes communications regarding the collection of any past due amounts even after your sailing.',
              )}
            </Typography>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default PaymentFooterWithModal;
